<script setup>
import {onUnmounted, onMounted, reactive, watch} from 'vue'
import {State} from '@/paks/vu-app'
import {clone, fixShadow, getModels, getRoute, getRoutes} from '@/paks/vu-app'
import Board from './Board.vue'

const props = defineProps({
    refresh: Number,
    view: Object,
})

const page = reactive({
    board: null,
    design: null,
    options: {expand: false},
    view: null,
})

defineExpose({page})

const {Dashboard} = getModels()

watch(
    () => State.app.needs.board,
    async (v) => {
        if (v == 'reload') {
            reload()
        }
    }
)

onMounted(async () => {
    reload()
})

function reload() {
    let path = getRoute().query?.path
    let view
    if (path) {
        view = getRoutes().getView(path)
        //  Design mode
        page.design = true
    } else {
        //  Live page mode
        view = getRoute().meta.view
        page.design = false
    }
    if (!view) return;
    page.view = clone(view)
    page.board = page.view.board || {}
    if (path) {
        page.board.live = false
    }
    page.board.fixed = true
    page.board.type = 'page'

    page.board = Dashboard.clean(page.board)
}

onUnmounted(() => {
    fixShadow()
})
</script>

<template>
    <Board
        v-if="page.board"
        v-model="page.board"
        :options="page.options"
        :design="page.design"
        :type="'page'"
        :view="page.view" />
</template>
